import { render, staticRenderFns } from "./AreaCascader.vue?vue&type=template&id=07d2e5fa&scoped=true&"
import script from "./AreaCascader.vue?vue&type=script&lang=js&"
export * from "./AreaCascader.vue?vue&type=script&lang=js&"
import style0 from "./AreaCascader.vue?vue&type=style&index=0&id=07d2e5fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d2e5fa",
  null
  
)

export default component.exports